import { createAction, props } from '@ngrx/store';
import { Destination } from '../../../objects/destination';
import { Storefront } from '../storefront.service';

export const setDestination = createAction(
  '[Destination] Set Destination',
  props<{destination: Destination | null}>(),
);

export const loadDestinations = createAction(
  '[Destination] Load Destinations',
  props<{storefront: Storefront | null}>(),
);

export const loadDestinationsSuccess = createAction(
  '[Destination] Load Destinations Success',
  props<{destinations: Destination[]}>(),
);

export const loadDestinationsFailure = createAction(
  '[Destination] Load Destinations Failure',
  props<{error: Error}>(),
);

export const loadDestination = createAction(
  '[Destination] Load Destination',
  props<{slugOrId: number | string}>(),
);

export const loadDestinationSuccess = createAction(
  '[Destination] Load Destination Success',
  props<{destination: Destination}>(),
);

export const loadDestinationFailure = createAction(
  '[Destination] Load Destination Failure',
  props<{error: Error}>(),
);
